import { BaseModel } from "../Generics/BaseModel"
import { CompanyEntity } from "../Company/CompanyEntity"

export class CompanySocialMediaEntity extends BaseModel {
  id: number

  userId: string

  companyEntityId: number

  instagramUrl: string

  facebookUrl: string

  whatsappUrl: string

  whatsAppPhone: string

  whatsappOrderSupportMessageTemplate: string

  tiktokUrl: string

  constructor(data: Partial<CompanySocialMediaEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.userId = data.userId ?? ""

    this.companyEntityId = data.companyEntityId ?? -1

    this.instagramUrl = data.instagramUrl ?? ""

    this.facebookUrl = data.facebookUrl ?? ""

    this.whatsappUrl = data.whatsappUrl ?? ""

    this.whatsAppPhone = data.whatsAppPhone ?? ""

    this.whatsappOrderSupportMessageTemplate = data.whatsappOrderSupportMessageTemplate ?? ""

    this.tiktokUrl = data.tiktokUrl ?? ""
  }

  update(
    instagramUrl?: string,
    facebookUrl?: string,
    whatsappUrl?: string,
    tiktokUrl?: string,
    whatsAppPhone?: string,
    whatsappOrderSupportMessageTemplate?: string,
  ) {
    this.instagramUrl = instagramUrl ?? ""

    this.facebookUrl = facebookUrl ?? ""

    this.whatsappUrl = whatsappUrl ?? ""

    this.whatsAppPhone = whatsAppPhone ?? ""

    this.whatsappOrderSupportMessageTemplate = whatsappOrderSupportMessageTemplate ?? ""

    this.tiktokUrl = tiktokUrl ?? ""
  }
}
